import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { breakpoints, colors } from '@/styles'
import { Label } from '@/components/text'
import { PadInfo, useBank, useAccountType, formatAccountNumber } from '@/features/Pad'
import LabeledValue from '@/components/labeled-value'
import { isNullOrEmpty } from '@/utils'

const PadAccountWrapper = styled.div`
  margin: 16px -20px 0;
  padding: 20px 20px 0;
  border-top: 1px solid ${colors.grey80};
  display: flex;
  flex-direction: column;
`

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    flex-direction: column;
  }
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 28px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    margin: 0;
  }
`

const Title = styled(Label)`
  color: ${colors.grey16};
  display: flex;
  align-items: center;

  svg {
    margin: 0 0 2px 4px;
  }
`

const AccountWrapper = styled.div`
  font-size: 14px;
  line-height: 16px;
  div:not(:last-child) {
    margin-bottom: 12px;
  }
`

type PadInfoLandlordProps = {
  paymentMethodInfo: PadInfo
}

const PadInfoLandlord: React.FC<PadInfoLandlordProps> = ({ paymentMethodInfo }) => {
  const { t } = useTranslation()
  const hasPadInfo = !isNullOrEmpty(paymentMethodInfo)
  const financialInfo = paymentMethodInfo?.financial_info
  const bank = useBank(financialInfo?.financial_institution_name)
  const account = useAccountType(financialInfo?.account_type)
  const accountNumber = formatAccountNumber(financialInfo?.account_number)

  return (
    <>
      <LabeledValue
        key="pad-requested"
        label={t('b.contract.edit.requested_payment_method.label', 'Requested payment method')}
        value={t('b.contract.edit.payment_method_pad.label', 'PAD (Pre-Authorized Debit)')}
      />
      {hasPadInfo && (
        <PadAccountWrapper>
          <ContentWrapper>
            <TextWrapper>
              <Title type="large">
                {t('b.contract.view.direct_debit_information.title', 'Direct Debit Information')}
              </Title>
            </TextWrapper>
          </ContentWrapper>
          <AccountWrapper>
            <LabeledValue
              label={t('b.contract.view.financial_institution.label', 'Financial institution')}
              value={bank}
            />
            <LabeledValue
              label={t('b.contract.view.account_type.label', 'Account type')}
              value={account}
            />
            <LabeledValue
              label={t('b.contract.view.account_number.label', 'Account number')}
              value={accountNumber}
            />
          </AccountWrapper>
        </PadAccountWrapper>
      )}
    </>
  )
}

export default PadInfoLandlord
